import React from 'react'
import './Support.scss'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import GridItem from 'reactor/components/Grid/GridItem'
import BoxItem from 'reactor/components/Box'
import { makeStyles } from '@material-ui/core/styles'
import Heading from '../../../components/heading'
import Link from 'reactor/components/Link'


export default function Support(props) {    

    const useStyles = makeStyles(theme => ({
        mainDiv: {
            backgroundImage: 'url(' + props.backgroundImage + ')',
            backgroundColor: props.backgroundColor,
            backgroundSize: '70%',
            backgroundPosition: 'bottom 0 right 4%',
            backgroundRepeat: 'no-repeat',
            color: props.color,
            padding: '6rem 0',
        },
        img: {
            maxWidth: '100%',
            margin: 'auto',
        },
        text: {
            fontSize: '20px',
            lineHeight: '1.7',
            fontWeight: '300',
            margin: '0 0 30px 0',
            textAlign: 'justify',
            '@media (max-width: 1400px)': {
                fontSize: '18px',
            },
            '@media (max-width: 1200px)': {
                fontSize: '16px',
            },
            '@media (max-width: 992px)': {
                fontSize: '14px',
            },
            '@media (max-width: 768px)': {
                fontSize: '12px',
                margin: '0 0 15px 0',
                maxWidth: "320px"
            },
        }
    }));

    const classes = useStyles();

    return (
        <div className={`support ${classes.mainDiv}`}>
            <Container>
                <GridItem sm={6} xs={12}>
                    <BoxItem display="flex" className="support-wrapper">
                        <GridItem>
                            {props.title && <Heading title={props.title} /> }
                            {props.content && <p className={classes.text}>{props.content}</p>}
                            <Link to="/contact-us" className={`btn-request ${props.btnClass}`}>تواصل الآن</Link>
                        </GridItem>
                    </BoxItem>
                </GridItem>
                <GridItem sm={6} xs={12}>
                    <img src={props.img} alt="" />
                </GridItem>
            </Container>
        </div>
    )
}